import styled, { keyframes } from 'styled-components';
const slideIn = keyframes` 
  0% {
    left: -100%;
    width: 0px; }
100% { 
  left: 0;
  width: 350px; 
}
`;
export const Container = styled.div`
  background: #fff;
  height: calc(100% - 70px);
  top: 70px;
  position: relative;
  z-index: 99;
  animation: ${props => (props.display ? slideIn : 'none')} 0.5s ease-in-out;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
  width: 350px;
  min-width: 350px;
`;

export const FieldTitle = styled.div`
  font-weight: bold;
  width: ${props => (props.isTitle ? '100%' : '40%')};
  color: ${props => (props.disabled ? '#b4b8bb;' : '#0e1318')};
  cursor: ${props => props.disabled && 'not-allowed'};
  box-shadow: ${props => props.isTitle && '0 1px 0 rgba(14, 19, 24, 0.15)'};
  padding: ${props => (props.checkBox ? '15px' : '20px')};
  font-size: 14px;
  display: flex;
  align-items: center;
  .anticon {
    margin-left: 12px;
  }
`;

export const RowSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  .ant-input {
    width: 200px !important;
  }
  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    clear: both;
    margin: 0;
    padding: 0 !important;
    text-align: center;
    color: rgba(0, 0, 0, 0.65);
    font-weight: bold !important;
    font-size: 35px !important;
    line-height: 50px !important;
  }
  .ant-select-dropdown-menu {
    overflow: hidden !important;
  }
  .ant-select-selection-selected-value{
    .variableType {
      display: none;
    }
  }
  
`;
